import {autoserializeAs} from "dcerialize";
import {ServerImage} from "../ServerImage";

export class FeaturedDetails {
  @autoserializeAs(() => Number)
  public readonly position: number;
  @autoserializeAs(() => String)
  public readonly subtitle: string;
  @autoserializeAs(() => String)
  public readonly teaser: string;
  @autoserializeAs(() => ServerImage)
  public readonly image: ServerImage;
}
